import { Component, OnInit, Input, ViewChild } from '@angular/core';
import * as _ from 'lodash';

//Constants
import { Hours } from 'src/app/constants/Hours.consts';
import { Days } from 'src/app/constants/Days.consts';

@Component({
  selector: 'dayparting-grid',
  templateUrl: './dayparting-grid.component.html',
  styleUrls: ['./dayparting-grid.component.scss']
})
export class DaypartingGridComponent implements OnInit {

  @Input() daypartGrid;
  @ViewChild("grid", { static: true }) tableGrid: any;

  cells: Array<any> = [];
  rows: Array<any> = [];
  hourLabel: Array<string>;
  dayLabel: Array<string>;
  hours = Hours;
  days = Days;
  startRow: any;
  startCol: any;
  endRow: any;
  endCol: any;
  clicking: boolean;
  hoverClass: string = 'hover-color';
  fixedClass: string = 'fixed-color';
  elements: any;

  constructor() { }

  ngOnInit() {
    this.elements = this.tableGrid.nativeElement;
    this.hourLabel = _.map(this.hours, 'label');
    this.dayLabel = _.map(this.days, 'label');
    this.genrateGrid();
  }

  //Get start cell range and end cell range using mouse events
  dragDropCellSelection(e, sr: number, sc: number) {
    if (e.type === 'mousedown') {
      this.clicking = true;
      this.startRow = sr;
      this.startCol = sc;
    }
    if (e.type === 'mouseup' && this.clicking) {
      this.clicking = false;
      let hoverClassEle = this.elements.querySelectorAll(`.${this.hoverClass}`);
      this.removeHoverClasses(hoverClassEle);
      this.endRow = sr;
      this.endCol = sc;
      this.updateSelection(false, this.startRow, this.startCol, this.endRow, this.endCol);
    }
  }

  //mouse move cell selection styling
  applySelectionColor(e) {
    if (this.clicking) {
      let hoverClassEle = this.elements.querySelectorAll(`.${this.hoverClass}`);
      this.removeHoverClasses(hoverClassEle);
      let id = e.target.attributes.id.value;
      let currentEndRow = parseInt(id[0]);
      let currentEndCol = parseInt(id.slice(1));
      this.updateSelection(true, this.startRow, this.startCol, currentEndRow, currentEndCol);
    }
  }

  //Remove hover class
  removeHoverClasses(els) {
    if (_.size(els) > 0) {
      for (let i = 0; i < _.size(els); i++) {
        els[i].classList.remove(this.hoverClass);
      }
    }
  }

  //Cell selection
  updateSelection(colorSelection, startRow: number, startCol: number, endRow: number, endCol: number) {
    if (startRow > endRow) {
      [startRow, endRow] = [endRow, startRow]
    }
    if (startCol > endCol) {
      [startCol, endCol] = [endCol, startCol]
    }
    for (let i = startRow; i <= endRow; i++) {
      for (let j = startCol; j <= endCol; j++) {
        if (colorSelection) {
          let el = this.tableGrid.nativeElement.querySelector(`[id='${i}${j}']`)
          el.classList.add(this.hoverClass);
        } else {
          this.daypartGrid[i][j] = !this.daypartGrid[i][j];
        }
      }
    }
  }

  //Handle grid styling
  changeStyle(e, row: number, col: number) {
    if (e && e.target) {
      let el = e.target;
      if (!el) return null;
      if (e.type == 'mouseenter') {
        el.classList.add(this.hoverClass);
      } else {
        el.classList.remove(this.hoverClass);
      }
      if (e.type == 'mouseleave' && this.daypartGrid[row][col]) {
        el.classList.add(this.fixedClass);
      }
    }
  }

  //on row header click, selects/un-selects particular row.
  selectWholeRow(row: number) {
    let selectedRowHeader = this.daypartGrid[row];
    _.forEach(selectedRowHeader, (value, index) => {
      selectedRowHeader[index] = !selectedRowHeader[index];
    });
  }

  //on column header click, selects/un-selects particular column.
  selectWholeColumn(col: number) {
    _.forEach(this.daypartGrid, (value) => {
      value[col] = !value[col];
    });
  }

  //Generate table grid
  genrateGrid() {
    for (var i = 0; i <= 6; i++) {
      this.cells.push(i);
    }
  }

  resetDaypart() {
    this.daypartGrid.length = 0;
    this.daypartGrid.push(...Array.from({ length: 24 }, () => Array(7).fill(true)));
  }

}